import { render, staticRenderFns } from "./team.vue?vue&type=template&id=a2512be6&"
import script from "./team.vue?vue&type=script&lang=js&"
export * from "./team.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a2512be6')) {
      api.createRecord('a2512be6', component.options)
    } else {
      api.reload('a2512be6', component.options)
    }
    module.hot.accept("./team.vue?vue&type=template&id=a2512be6&", function () {
      api.rerender('a2512be6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/svg/team.vue"
export default component.exports